export const ACCOUNT_LOCKED = 'accountLocked';
export const INVALID_CREDENTIALS = 'invalidCredentials';
export const USER_NOT_FOUND = 'userNotFound';
export const VALIDATION_ERROR = 'validationError';
export const SERVER_ERROR = 'serverError';
